export const TABLE_ROW_HEIGHT = 80;
export const AG_GRID_CONFIG_TABLE_ROW_HEIGHT = 90;
